import { render, staticRenderFns } from "./AppWijzigenZelf.vue?vue&type=template&id=53e1d5d7&scoped=true&"
import script from "./AppWijzigenZelf.ts?vue&type=script&lang=ts&"
export * from "./AppWijzigenZelf.ts?vue&type=script&lang=ts&"
import style0 from "./AppWijzigenZelf.scss?vue&type=style&index=0&id=53e1d5d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1d5d7",
  null
  
)

export default component.exports